import {Pipe, PipeTransform} from '@angular/core';

import moment from 'moment-timezone';

import { LocalizationService } from '../../../../Core/Localization/services/localization.service';


@Pipe({
    name: 'relativeTime',
    standalone: false
})
export class RelativeTimePipe implements PipeTransform {
    constructor (private localizationService: LocalizationService) {}

    transform(value: Date) {
        if (!(value instanceof Date)) {
            value = new Date(value);
        }

        const seconds: number = Math.floor(moment().unix() - (value.getTime() / 1000));

        // 31536000s is 1 year
        let interval: number = Math.floor(seconds / 31536000);
        if (interval >= 1) {
            return interval + this.localizationService.transform('relativeTimeSuffixes.year');
        }

        // 2592000s is 30 days
        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
            return interval + this.localizationService.transform('relativeTimeSuffixes.month');
        }

        interval = Math.floor(seconds / 604800);
        if (interval >= 1) {
            return interval + this.localizationService.transform('relativeTimeSuffixes.week');
        }

        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
            return interval + this.localizationService.transform('relativeTimeSuffixes.day');
        }

        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
            return interval + this.localizationService.transform('relativeTimeSuffixes.hour');
        }

        interval = Math.floor(seconds / 60);

        if (interval >= 1) {
            return interval + this.localizationService.transform('relativeTimeSuffixes.minute');
        }
        return Math.floor(seconds) + this.localizationService.transform('relativeTimeSuffixes.second');
    }
}
